import { render, staticRenderFns } from "./ViewGatGridColumns.vue?vue&type=template&id=bc645410&scoped=true&"
import script from "./ViewGatGridColumns.vue?vue&type=script&lang=js&"
export * from "./ViewGatGridColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc645410",
  null
  
)

export default component.exports